
export const Gray1 = '#828282';
export const Gray2 = '#F2F2F2';

export const Yellow = '#FEC108';

const Colors = {
  Gray1: Gray1,
  Gray2: Gray2,
  Yellow: Yellow
};

export default Colors;
